export const LOCAL_STORAGE = {
    KEYS: {
        ID_USUARIO    : 'IU',
        ID_ROL        : 'IR',
        ID_EMPRESA    : 'IE',
        NOMBRE_USUARIO: 'NU',
        USUARIO       : 'U',
        TOKEN_VALID   : 'TV',
        HOSTNAME      : 'NH',
        DBNAME        : 'ND'
    }
};
